// features/ApprovalRequest/ApprovalRequestAddEditView/index.tsx
import React, { FC, useEffect } from "react";
import { default as ApprovalRequestAddEditBaseView } from './base';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router";
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { observer } from "mobx-react";
import store from "./store";
import CustomButton from 'components/Button';
import MtmTabs from "./mtmTabs";

type ApprovalRequestProps = {};

const ApprovalRequestAddEditView: FC<ApprovalRequestProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const query = useQuery();
  const id = query.get("id");

  useEffect(() => {
    if ((id != null) &&
      (id !== '') &&
      !isNaN(Number(id.toString()))) {
      store.doLoad(Number(id));
    } else {
      // New approval request - id = 0
      store.clearStore();
    }
    return () => {
      store.clearStore();
    }
  }, []);

  return (
    <ApprovalRequestAddEditBaseView {...props}>

      {/* start MTM */}
      <div style={{marginTop: 20}}></div> 
      {store.id > 0 && <Grid item xs={12} spacing={0}><MtmTabs /></Grid>}
      {/* end MTM */}
      
      <Box display="flex" p={2}>
        {/* <Box m={2}>
            {!store.disableEdit ? <CustomButton
            variant="contained"
            id="id_ApprovalRequestSaveButton"
            onClick={() => {
              store.onSaveClick((id: number) => {
                if (store.id === 0) {
                  store.doLoad(id);
                  navigate(`/user/ApprovalRequest/addedit?id=${id}`);
                }
              });
            }}
          >
            {translate("common:save")}
          </CustomButton> : <></>}
        </Box> */}
        <Box m={2}>
          <CustomButton
            color={"secondary"}
            sx={{color:"white", backgroundColor: "red !important"}}
            variant="contained"
            id="id_ApprovalRequestCancelButton"
            onClick={() => navigate('/user/ApprovalRequest')}
          >
            {translate("common:goOut")}
          </CustomButton>
        </Box>
      </Box>
    </ApprovalRequestAddEditBaseView>
  );
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default ApprovalRequestAddEditView;